import axios from "axios";
import { handleResponse, handleError } from "./ResponseService";
axios.defaults.withCredentials = true;

const post = (resource, body, options) => {
  return axios
    .post(resource, body, options)
    .then(handleResponse)
    .catch(handleError);
};
const get = (resource, options) => {
  return axios.get(resource, options).then(handleResponse).catch(handleError);
};

let obj = { post, get };
export default obj;
